import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { Mobile } from 'components/responsive';
import TimeSeries from "components/emissions-demo/components/time-series";

import { citiesInfo } from 'components/emissions-demo/constants';

import './style.css';

// eslint-disable-next-line react/prefer-stateless-function
class TopBar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onChangeArea = this.onChangeArea.bind(this);
    this.onChangePollutant = this.onChangePollutant.bind(this);
    this.onChangeSector = this.onChangeSector.bind(this);
    this.onChangeCity = this.onChangeCity.bind(this);
    this.onChangeProductType = this.onChangeProductType.bind(this)
  }

  /**
   * Event hander executed when the user changes the area
   * @param {{ label: string, value: string }} area Selected area
   */
  onChangeArea(area) {
    const { setArea, setViewport } = this.props;
    setArea(area, true);
    setViewport({});
  }

  /**
 * Event hander executed when the user changes the product type
 * @param {{ label: string, value: string }} productType Selected type of product
 */
  onChangeProductType({ value: productType }) {
    const { setProductType, products } = this.props;
    const SelectedProduct = products.find(product => product.id === productType);
    setProductType(SelectedProduct);
  }

  /**
  * Event hander executed when the user changes the city
  * @param {{ label: string, value: string }} city Selected city
  */
  onChangeCity(city) {
    const { setCity } = this.props;
    setCity(city);
  }

  /**
   * Event hander executed when the user changes the pollutant
   * @param {{ label: string, value: string }} pollutant Selected pollutant
   */
  onChangePollutant(pollutant) {
    const { setPollutant } = this.props;
    setPollutant(pollutant);
  }

  /**
   * Event hander executed when the user changes the sector
   * @param {{ label: string, value: string }} sector Selected sector
   */
  onChangeSector(sector) {
    const { setSector } = this.props;
    setSector(sector);
  }


  render() {
    const { productTypes, selectedArea, selectedProductType, pollutants, selectedPollutant, sectors, selectedSector, selectedCity } = this.props;
    return (
      <div className="c-emissions-top-bar">
        <div className="top-bar-area">
          {selectedArea && (
            <h1 className="area-info top-bar-item">{selectedArea.label}</h1>
          )}
          {/* <Select classNamePrefix="react-select" placeholder="Select an area" options={areas} value={selectedArea} onChange={this.onChangeArea} /> */}
          {/* TO-DO - Go back to Select when API gets updated, (define areas and selectedArea) */}
        </div>
        <div className="top-bar-selects">
          <Select
            value={selectedProductType}
            className="top-bar-item"
            classNamePrefix="react-select"
            placeholder="Resolution"
            options={productTypes}
            onChange={this.onChangeProductType}
          />
          <Select
            value={selectedCity}
            className="top-bar-item"
            classNamePrefix="react-select"
            placeholder="City"
            options={citiesInfo}
            onChange={this.onChangeCity}
          />
          <Select
            value={selectedPollutant}
            className="top-bar-item"
            classNamePrefix="react-select"
            placeholder="Pollutants"
            options={pollutants}
            onChange={this.onChangePollutant}
          />
          <Select
            value={selectedSector}
            className="top-bar-item"
            classNamePrefix="react-select"
            placeholder="Sector"
            options={sectors}
            onChange={this.onChangeSector}
          />
        </div>
        <Mobile>
          <TimeSeries/>
        </Mobile>
      </div>
    );
  }
}

const optionPropType = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

TopBar.propTypes = {
  // Area options for the selector
  areas: PropTypes.arrayOf(optionPropType).isRequired,
  // Selected area option
  selectedArea: optionPropType,
  // Types of products options for the selector
  productTypes: PropTypes.arrayOf(optionPropType).isRequired,
  // Selected product type option
  selectedProductType: optionPropType,
  // Pollutant options for the selector
  pollutants: PropTypes.arrayOf(optionPropType).isRequired,
  // Selected pollutant option
  selectedPollutant: optionPropType,
  // Sector options for the selector
  sectors: PropTypes.arrayOf(optionPropType).isRequired,
  // Selected sector opttion
  selectedSector: optionPropType,
  // Set the selected area
  setArea: PropTypes.func.isRequired,
  // Set the selected pollutant
  setPollutant: PropTypes.func.isRequired,
  // Set the selected sector
  setSector: PropTypes.func.isRequired,
  setViewport: PropTypes.func.isRequired
};

TopBar.defaultProps = {
  selectedArea: null,
  selectedProductType: null,
  selectedPollutant: null,
  selectedSector: null
};

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/emissions-demo/components/top-bar/component.js